<div class="row offset-2 col-10 pl-0 pr-0">
    <div class="col-12 card align-self-center">
        <div class="card-body">
            <h3 class="text-themecolor m-b-0 m-t-0">Page</h3>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
                <li class="breadcrumb-item active">Page</li>
            </ol>
        </div>
    </div>
</div>